export default __webpack_public_path__ + "static/media/pic16.85c441a6.jpg";